import React from 'react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen">
      <div className="py-24 md:py-32 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-7xl tracking-tighter leading-[0.9] font-medium font-heading mb-12">
              Terms & <span className="text-primary">Conditions</span>
            </h1>

            <div className="space-y-8 text-base leading-relaxed tracking-wide">
              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  1. Réservations
                </h2>
                <p className="text-foreground-muted">
                  Les réservations doivent être effectuées au moins 48 heures à l'avance. 
                  Nous limitons le nombre de sessions par jour pour garantir la qualité de production.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  2. Paiement
                </h2>
                <p className="text-foreground-muted mb-3">
                  Le paiement intégral est requis au moment de la réservation via notre système de paiement sécurisé Stripe.
                </p>
                <p className="text-foreground-muted">
                  Toutes les réservations incluent un technicien professionnel et 2 caméras 4K.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  3. Annulation
                </h2>
                <p className="text-foreground-muted">
                  Les réservations sont non remboursables dans les 48 heures précédant la session programmée. 
                  Pour les annulations effectuées plus de 48 heures à l'avance, un remboursement de 50% sera accordé.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  4. Durée de Session
                </h2>
                <p className="text-foreground-muted">
                  La durée minimale de réservation est de 2 heures. Les sessions peuvent être prolongées sous réserve de disponibilité.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  5. Équipement
                </h2>
                <p className="text-foreground-muted">
                  Tout l'équipement du studio doit être manipulé avec soin. Vous serez tenu responsable de tout dommage causé par négligence.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  6. Contenu
                </h2>
                <p className="text-foreground-muted">
                  Vous conservez tous les droits sur votre contenu. Canggu Podcast Studio peut utiliser des extraits à des fins promotionnelles avec votre autorisation préalable.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  7. Services de Montage
                </h2>
                <p className="text-foreground-muted">
                  Les services de montage sont disponibles uniquement pour le contenu en anglais. 
                  Les délais de livraison standard sont de 7-10 jours ouvrables, sauf si un service express est demandé.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  8. Livraison des Fichiers
                </h2>
                <p className="text-foreground-muted">
                  Les fichiers bruts seront livrés via notre plateforme cloud dans les 24 heures suivant votre session.
                </p>
              </section>

              <section>
                <h2 className="text-2xl md:text-3xl font-heading font-light mb-4 text-primary">
                  9. Contact
                </h2>
                <p className="text-foreground-muted">
                  Pour toute question concernant ces conditions, veuillez nous contacter via WhatsApp ou par email.
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-border">
              <p className="text-sm text-foreground-muted">
                Dernière mise à jour : Mars 2026
              </p>
            </div>

            <div className="mt-8">
              <a
                href="/"
                className="inline-block px-6 py-3 border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-200"
              >
                Retour à l'Accueil
              </a>
            </div>
          </motion.div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
